// export const PaymentTransactionModal = ({ transaction, onClose }) => {
//   if (!transaction) return null;

//   return (
//     <div className="fixed inset-0 bg-[var(--black)]  border-gray-50  flex justify-center items-center">
//       <div className=" p-6 rounded-xl w-[500px]">

//         <h2 className="text-xl font-bold mb-4">
//           Payment Details
//         </h2>

//         <p><b>User:</b> {transaction.user?.fullName}</p>
//         <p><b>Package:</b> {transaction.packageName}</p>
//         <p><b>Coins:</b> {transaction.coins}</p>
//         <p><b>Amount:</b> ₹{transaction.amount}</p>
//         <p><b>Status:</b> {transaction.status}</p>
//         <p><b>Order ID:</b> {transaction.razorpayOrderId}</p>
//         <p><b>Payment ID:</b> {transaction.razorpayPaymentId}</p>

//         <button
//           onClick={onClose}
//           className="mt-4 px-4 py-2 bg-red-500 text-white rounded"
//         >
//           Close
//         </button>
//       </div>
//     </div>
//   );
// };




export const PaymentTransactionModal = ({ transaction, onClose }) => {
  if (!transaction) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center  bg-[var(--black)] k px-4">
      
      {/* Modal Container */}
      <div
        className="
          w-full max-w-[500px]
          rounded-2xl
          border border-gray-300
           bg-[var(--black)] 
          p-6
          shadow-2xl
        "
      >
        {/* Header */}
        <div className="mb-5 flex items-center justify-between border-b border-gray-200 pb-4">
          <h2 className="text-xl font-bold text-white-900">
            Payment Details
          </h2>

          <button
            onClick={onClose}
            className="text-xl text-gray-500 transition hover:text-gray-900"
          >
            ✕
          </button>
        </div>

        {/* Details */}
        <div className="space-y-3 text-sm">
          <p>
            <b>User:</b> {transaction.user?.fullName}
          </p>

          <p>
            <b>Package:</b> {transaction.packageName}
          </p>

          <p>
            <b>Coins:</b> {transaction.coins}
          </p>

          <p>
            <b>Amount:</b> ₹{transaction.amount}
          </p>

          <p>
            <b>Status:</b>{" "}
            <span className="rounded-full bg-green-100 px-3 py-1 text-xs font-semibold text-green-700">
              {transaction.status}
            </span>
          </p>

          <div className="border-t border-gray-200 pt-3">
            <p className="break-all">
              <b>Order ID:</b> {transaction.razorpayOrderId}
            </p>

            <p className="mt-3 break-all">
              <b>Payment ID:</b> {transaction.razorpayPaymentId}
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-6 border-t border-gray-200 pt-4">
          <button
            onClick={onClose}
            className="
              w-full rounded-xl
              bg-red-500
              px-4 py-2.5
              font-semibold text-white
              transition
              hover:bg-red-600
              active:scale-[0.98]
            "
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};
